import { useEffect, useState } from 'react';
import type { Engagement } from '../../lib/types';
import { getPublicEngagements } from '../../lib/api';
import { BookingCta } from '../components/BookingCta';
import { EngagementList } from '../components/EngagementList';

const initialEngagements: Engagement[] = [
  { id: 'spain-2026', title: 'Beyond the Diagnosis', organization: 'Traditional Medicine Conference', location: 'Spain', startsAt: null, dateLabel: '6/26', format: 'virtual', status: 'completed', summary: 'Traditional Chinese Medicine, targeted conditioning, and Qigong for active self-cultivation.', description: '', eventUrl: null, imageId: null, sortOrder: 1 },
  { id: 'hong-kong-2026', title: 'Healthcare Insights 2026', organization: 'Healthcare Insights', location: 'Hong Kong', startsAt: null, dateLabel: '11/26', format: 'virtual', status: 'upcoming', summary: '', description: '', eventUrl: null, imageId: null, sortOrder: 2 },
  { id: 'las-vegas-2027', title: 'Healthcare 2.0', organization: 'Healthcare 2.0 Conference', location: 'Las Vegas', startsAt: null, dateLabel: '14/27', format: 'in_person', status: 'upcoming', summary: '', description: '', eventUrl: null, imageId: null, sortOrder: 3 },
  { id: 'italy-2027', title: 'Traditional Medicine Conference', organization: 'Traditional Medicine Conference', location: 'Italy', startsAt: null, dateLabel: '6/27', format: 'in_person', status: 'upcoming', summary: '', description: '', eventUrl: null, imageId: null, sortOrder: 4 }
];

export function EngagementsPage() {
  const [engagements, setEngagements] = useState(initialEngagements);

  useEffect(() => {
    let active = true;

    getPublicEngagements()
      .then((publishedEngagements) => {
        if (active) setEngagements(publishedEngagements);
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <header className="page-hero engagements-hero">
        <p className="eyebrow">On stage · Online · In practice</p>
        <h1>Speaking Engagements</h1>
        <p className="page-hero__lead">Current and recent conversations across wellness, healthcare, and integrative medicine.</p>
      </header>
      <section className="engagements-section" aria-label="Engagements">
        <EngagementList engagements={engagements} />
      </section>
      <BookingCta />
    </>
  );
}
